export default __webpack_public_path__ + "static/media/aristo-detail.74d272cf.svg";